import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import AspectRatio from 'components/utils/AspectRatio'
import styled from 'styled-components'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Image from 'components/Common/Image/Image'

const FillHeightGroup = styled(Group)`
  height: 100%;
`

const WhyWeLoveTileContainer = styled.div`
  width: 75vw;

  ${mediaQueryUp.tablet} {
    width: 40vw;
  }
  ${mediaQueryUp.desktop} {
    width: unset;
  }
`

export type Tag = {
  name: string
  url: string
}

interface Props {
  imageId: string
  title: string
  description: string
  url?: string
}

function WhyWeLoveTile(props: Props) {
  return (
    <WhyWeLoveTileContainer>
      <FillHeightGroup direction="vertical" gap={12} verticalAlign="space-between">
        <VerticalSpacer gap={12}>
          <AspectRatio ratio="16:9">
            <Image aspectRatio="16:9" id={props.imageId} fit="center" dpr={2} width="375" />
          </AspectRatio>
          <BodyText variant="large" lineClamp={2} weight="bold">{props.title}</BodyText>
          <BodyText variant="medium">{props.description}</BodyText>
        </VerticalSpacer>
      </FillHeightGroup>
    </WhyWeLoveTileContainer>
  )
}

export default WhyWeLoveTile
